import styled from "styled-components";
import { ate } from "../../../global/breakpoints";

// ===== INTERFACE DO TEMA =====
interface Theme {
  colors: {
    background: string;
    text: string;
    selection: string;
    modalColor: string;
    border: string;
    primary?: string;
    danger?: string;
    selectionDark?: string;
    textOnPrimary?: string;
    label?: string;
    borderColor?: string;
  };
}

// ===== COMPONENTES DE MODAL =====
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* A gaveta encosta no pe' da tela: o alinhamento deixa de ser central. */
  ${ate.tablet} {
    align-items: flex-end;
  }
`;

export const ModalContent = styled.div<{ large?: boolean; medium?: boolean }>`
  background: ${(props) => props.theme.colors.modalColor || "#fff"};
  padding: var(--sp-24);
  border-radius: 12px;
  width: ${(props) => (props.large ? "95%" : props.medium ? "80%" : "60%")};
  max-width: ${(props) =>
    props.large ? "calc(var(--u) * 1400)" : props.medium ? "calc(var(--u) * 1000)" : "calc(var(--u) * 800)"};
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-20px);
  animation: slideIn 0.3s ease forwards;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  /*
   * NO CELULAR ESTA CAIXA VIRA GAVETA — e nao e' preferencia, e' conserto.
   *
   * Com "width: 60%" um modal normal tem 225px num telefone de 375: dois
   * campos lado a lado nao cabem, e o titulo quebra em cinco linhas. O
   * "large" (95%) chega perto da largura toda mas continua centrado na
   * vertical, com as bordas arredondadas cortadas pelo topo e pelo pe' da
   * tela.
   *
   * A gaveta de baixo resolve os dois: ocupa a largura inteira, encosta no pe'
   * da tela (que e' onde o polegar esta') e so' arredonda em cima, que e' a
   * unica borda que aparece.
   *
   * O 100dvh CONTRA 100vh, que veio de um defeito MEDIDO no FlyOps.
   *
   * Relato da operacao la', em 24/08/2026: "nao consigo clicar na renuncia do
   * seguro flex no mobile, nao deixa puxar mais". A gaveta usava 100vh — e no
   * celular 100vh e' a viewport GRANDE, a que inclui a faixa coberta pela
   * barra do navegador. A gaveta ficava mais alta que a area visivel, o rodape
   * grudava no fim dela (fora da tela) e a rolagem interna terminava sem nunca
   * revelar os botoes. O 100dvh acompanha a altura realmente visivel.
   *
   * Aqui o vh de cima e' "max-height: 90vh", com o mesmo defeito: os botoes de
   * Salvar e Cancelar caem atras da barra do navegador. Sao 92dvh porque a
   * sobra de 8% mostra o escuro do overlay em cima e deixa claro que da' para
   * fechar tocando fora.
   *
   * NADA DISTO MUDA A TELA GRANDE. A trava do gabarito visual exige diferenca
   * ZERO em 1440px, e uma media query de max-width 768 nunca chega la'.
   */
  ${ate.tablet} {
    width: 100%;
    max-width: 100%;
    max-height: 92dvh;
    margin-top: auto;
    padding: var(--sp-16);
    border-radius: 16px 16px 0 0;
    animation: subirGaveta 0.28s ease forwards;
  }

  @keyframes subirGaveta {
    from {
      transform: translateY(24px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--fs-xl);
  font-weight: bold;
  padding-bottom: var(--sp-16);
  border-bottom: 1px solid
    ${(props) => props.theme.colors.borderColor || "#e0e0e0"};

  /*
   * Grudado no topo da gaveta. Numa gaveta que rola, o titulo e o X somem
   * assim que a pessoa desce dois campos — e sem o X visivel o unico jeito de
   * sair passa a ser rolar de volta ate' em cima.
   *
   * O fundo opaco e' obrigatorio: sem ele o conteudo passa POR TRAS do titulo
   * e as duas camadas de texto se sobrepoem.
   */
  ${ate.tablet} {
    position: sticky;
    top: calc(var(--sp-16) * -1);
    z-index: 2;
    margin: calc(var(--sp-16) * -1) calc(var(--sp-16) * -1) 0;
    padding: var(--sp-16);
    background: ${(props) => props.theme.colors.modalColor || "#fff"};
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-top: var(--sp-16);
  max-height: calc(90vh - calc(var(--u) * 120));

  &::-webkit-scrollbar {
    width: calc(var(--u) * 12);
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background + "40"};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.selection};
    border-radius: 6px;
    border: 2px solid ${(props) => props.theme.colors.background + "40"};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) =>
      props.theme.colors.selectionDark || props.theme.colors.selection};
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  max-height: calc(var(--u) * 600);
  flex: 1;
  overflow: hidden;

  /*
   * TRES CONSERTOS NUMA REGRA SO', e o do meio e' o grave.
   *
   * 1. "flex-direction: row" poe as colunas lado a lado. Num telefone cada
   *    uma fica com metade de 375px, e o formulario vira uma coluna de
   *    palavras cortadas. Em coluna, cada bloco usa a largura toda.
   *
   * 2. "overflow: hidden" com altura limitada NAO ESCONDE: ELIMINA. O que
   *    passa do corte nao aparece e nao tem barra de rolagem para alcancar —
   *    num modal alto, os ultimos campos simplesmente nao existem para quem
   *    esta' no celular. O auto devolve a rolagem.
   *
   * 3. O teto de 600u e' desenho de tela grande. Na gaveta quem manda na
   *    altura e' a propria gaveta (92dvh), entao ele sai.
   */
  ${ate.tablet} {
    flex-direction: column;
    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }
`;

export const ModalTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: var(--sp-12);
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.selection};
  font-size: var(--fs-2xl);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-8);
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors.selection + "20"};
  }
`;

export const ModalFooter = styled.div`
  padding-top: var(--sp-20);
  border-top: 1px solid ${(props) => props.theme.colors.border};
  margin-top: auto;

  /*
   * Grudado no pe' da gaveta, pelo mesmo motivo do cabecalho: sao os botoes de
   * Salvar e Cancelar. Um formulario longo empurrava os dois para fora da
   * area visivel, e a pessoa rolava sem saber que havia botao.
   *
   * Fundo opaco, sem transparencia: o rodape fica por cima de conteudo denso
   * (tabelas, listas), e translucido ali confunde em vez de enfeitar.
   */
  ${ate.tablet} {
    position: sticky;
    bottom: calc(var(--sp-16) * -1);
    z-index: 2;
    margin: 0 calc(var(--sp-16) * -1) calc(var(--sp-16) * -1);
    padding: var(--sp-12) var(--sp-16)
      calc(var(--sp-12) + env(safe-area-inset-bottom, 0px));
    background: ${(props) => props.theme.colors.modalColor || "#fff"};
  }
`;

/**
 * O resultado do último Salvar, dito dentro do modal.
 *
 * Existe porque `setMessageZustand` não pinta nada aqui: o `MessageBox` que lê
 * `messageZustand` só está montado em LoginPage e RegisterPage. Mesmo desenho
 * do `Aviso` da aba Meios de Pagamento, que já está em produção.
 */
export const AvisoDoSalvamento = styled.div<{
  $tom: "ok" | "erro" | "atencao";
}>`
  margin-top: var(--sp-12);
  padding: var(--sp-10) var(--sp-16);
  border-radius: 8px;
  font-size: var(--fs-md);
  line-height: 1.4;
  border: 1px solid
    ${(props) =>
      props.$tom === "erro"
        ? "#be3028"
        : props.$tom === "atencao"
        ? "#8f5e07"
        : "#26792f"};
  background-color: ${(props) =>
    props.$tom === "erro"
      ? "#be302818"
      : props.$tom === "atencao"
      ? "#8f5e0718"
      : "#26792f18"};
  color: ${(props) => props.theme.colors.text};
`;

// ===== SITUAÇÃO DA FILA =====
// Mesmo desenho do precedente que já está em produção na aba Meios de
// Pagamento (styles/.../storesSection/MeiosPagamento.ts). Repetir o desenho é
// de propósito: a Configuração mostra a fila de um jeito só.
export const FilaCaixa = styled.div`
  margin-top: var(--sp-12);
  padding: var(--sp-12) var(--sp-16);
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.selection + "30"};
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.label};
`;

export const FilaTitulo = styled.div`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: var(--sp-6);
`;

export const FilaItem = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-6);
  padding: var(--sp-2) 0;

  .material-icons {
    font-size: var(--fs-base);
  }
`;

/**
 * Aviso curto embaixo de um campo — o que explica por que ele está travado.
 * Discreto de propósito: é uma nota de rodapé do campo, não um alerta.
 */
export const NotaDeCampo = styled.div`
  margin: 0 var(--sp-10) var(--sp-10) var(--sp-20);
  font-size: var(--fs-md);
  line-height: 1.4;
  color: ${(props) => props.theme.colors.label};

  code {
    font-family: monospace;
  }
`;

// ===== COMPONENTES DE ITEM =====
export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: var(--sp-10);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
`;

export const ItemTopContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const ItemBottom = styled.div`
  display: flex;
  height: 50%;
  overflow: hidden;
  /* Âncora do botão "Tela cheia", que é absoluto no canto. */
  position: relative;
`;

export const ItemInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  padding: var(--sp-10);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  height: calc(var(--u) * 350);
`;

export const ItemInfoFields = styled.div`
  overflow-y: auto;
  height: calc(var(--u) * 330);
  background-color: ${(props) => props.theme.colors.background};
  width: 50%;
`;

export const ItemInfo = styled.div<{ selected: boolean }>`
  padding: var(--sp-10);
  margin-bottom: var(--sp-10);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--sp-10);
  border: 1px solid #000000;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  color: ${({ selected }) => (selected ? "#000000" : "inherit")};
  background: ${({ selected }) =>
    selected ? "rgba(255, 196, 0, 0.372)" : "inherit"};
  &:hover {
    color: "#000000";
    background: rgba(255, 196, 0, 0.372);
  }
`;

// ===== COMPONENTES DE LAYOUT =====
export const Column = styled.div`
  padding: var(--sp-10);
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const LabelInputContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  padding: var(--sp-10);
  margin-left: var(--sp-10);
  align-self: start;
  font-weight: bold;
  color: ${(props) => props.theme.colors.label};
  position: relative;
  white-space: nowrap;

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-10%);
    top: 100%;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  &:hover {
    cursor: help;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateX(-5%) translateY(-35px);
  }
`;

// ===== COMPONENTES DE FORMULÁRIO =====
export const TextInput = styled.div`
  /*
   * O CAMPO NAO E' PINTADO COM A TINTA — e' o contrario: fundo claro, tinta na
   * borda e no texto.
   *
   * Ele JA' FOI pintado, e por minha causa. Quando a paleta do sistema de
   * design entrou, "colors.selection" deixou de ser o azul claro do rosto do
   * icone (#88DBFE) e passou a ser a TINTA (#0976C4), azul cheio. As duas
   * coisas se chamam igual nesta base — "selection" aparece em 520 lugares,
   * 124 como fundo e 114 como texto — entao trocar o VALOR consertou o texto e
   * arrebentou os campos: viraram retangulos azuis escuros com rotulo PRETO
   * por cima.
   *
   * Medido no navegador, num modal so': 36 elementos com esse fundo, 32 abaixo
   * do minimo de contraste. O pior era 1,21:1 — o texto de dica do select, que
   * na pratica sumia.
   *
   * Aqui o papel de cada um volta ao lugar: o fundo do campo e' a superficie da
   * pagina, a tinta fica na BORDA (passa no 1.4.11 com folga) e o rotulo usa a
   * cor de texto do TEMA em vez de "black" fixo — que era outro defeito
   * escondido, porque no tema escuro preto sobre escuro nao aparece.
   *
   * O botao primario continua com fundo "selection": la' o texto e' branco, e
   * com a tinta ele MELHOROU (era 1,7:1 com o azul claro, agora e' 4,9:1).
   */
  padding: var(--sp-10);
  margin-left: var(--sp-10);
  position: relative;
  width: 100%;
  input {
    width: 100%;
    padding: var(--sp-8);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 4px;
    outline: none;
    background: ${(props) => props.theme.colors.background};
    /* Sem esta linha o campo herda o preto padrao do navegador: no tema escuro
       isso e' preto sobre #252525, medido em 1,37:1 — o que a pessoa digita
       fica invisivel. */
    color: ${(props) => props.theme.colors.text};
  }

  label {
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 20);
    transform: translateY(-50%);
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    cursor: help;
    display: flex;
    align-items: center;
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(var(--u) * 10);
    left: 0;
    font-weight: bold;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  label:hover + .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    border-radius: 10px;
    top: calc(var(--u) * 20);
    left: calc(var(--u) * 30);
    transform: scale(1.1) translateY(-100%);
  }

  input:focus {
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

export const DropdownInput = styled.div`
  padding: var(--sp-10);
  margin-left: var(--sp-10);
  position: relative;
  width: 100%;

  select {
    width: 100%;
    padding: var(--sp-8);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 4px;
    outline: none;
    background: ${(props) => props.theme.colors.background};
    /* Sem esta linha o campo herda o preto padrao do navegador: no tema escuro
       isso e' preto sobre #252525, medido em 1,37:1 — o que a pessoa digita
       fica invisivel. */
    color: ${(props) => props.theme.colors.text};
    cursor: pointer;
  }

  label {
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 15);
    transform: translateY(-50%);
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    cursor: help;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(var(--u) * 10);
    left: 0;
    font-weight: bold;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  label:hover + .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  select:focus ~ label,
  select:valid ~ label {
    border-radius: 10px;
    top: calc(var(--u) * 20);
    left: calc(var(--u) * 30);
    transform: scale(1.1) translateY(-100%);
  }

  select:invalid {
    /* Era "gray" (#808080): 3,74:1 sobre o creme da pagina, medido — abaixo do
       minimo. O carvao-2 do sistema de design faz o mesmo trabalho de "isto e'
       so' a dica, nao um valor escolhido" e chega a 6,5:1. */
    color: ${(props) => props.theme.colors.label};
  }
`;

// ===== COMPONENTES DE INFORMAÇÃO =====
export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 250), 1fr));
  gap: var(--sp-16);
  margin-top: var(--sp-16);
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
  padding: var(--sp-16);
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  font-size: var(--fs-xs);
  color: ${(props) => props.theme.colors.label};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: calc(var(--u) * 0.5);
`;

export const InfoValue = styled.div<{ status?: boolean }>`
  font-size: var(--fs-md);
  font-weight: 600;
  color: ${(props) =>
    props.status === undefined
      ? props.theme.colors.text
      : props.status
      ? "#4CAF50"
      : "#F44336"};
`;

// ===== COMPONENTES DE CAMPOS =====
export const FieldsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 85%;
  max-height: 85%;
  padding: var(--sp-24);
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;

  &::-webkit-scrollbar {
    width: calc(var(--u) * 15);
    height: calc(var(--u) * 15);
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.modalColor + "90"};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.selection};
    border-radius: 10px;
    border: 2px solid ${(props) => props.theme.colors.modalColor + "90"};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.colors.selectionDark};
    cursor: grab;
  }

  &::-webkit-scrollbar-thumb:active {
    cursor: grabbing;
  }
  &:hover {
    scrollbar-width: auto;
  }
  scrollbar-color: ${(props) => props.theme.colors.selection};
`;

export const SectionTitle = styled.h3`
  font-size: var(--fs-xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0 0 var(--sp-16) 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 250), 1fr));
  gap: var(--sp-16);
  margin-bottom: var(--sp-16);
`;

export const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 150), 1fr));
  gap: var(--sp-16);
  margin-bottom: var(--sp-16);
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
  width: 100%;

  label {
    font-weight: 600;
    font-size: var(--fs-md);
    color: ${(props) => props.theme.colors.text};
    display: flex;
    align-items: center;
    gap: var(--sp-8);
  }

  input,
  select,
  textarea {
    box-sizing: border-box;
    width: 100%;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: var(--sp-12);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 6px;
  font-size: var(--fs-md);
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.selection};
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.label};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: var(--sp-12);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 6px;
  font-size: var(--fs-md);
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.selection};
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
  }

  option {
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
  }
`;

// ===== COMPONENTES DE COR =====
export const ColorInput = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: var(--sp-20);

  input[type="color"] {
    width: calc(var(--u) * 30);
    height: calc(var(--u) * 30);
    border-radius: 50%;
    background-color: ${(props) => props.color};
    cursor: pointer;
    border: none;
    padding: 0;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: none;
  }

  input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
    border-radius: 50%;
  }

  input[type="color"]::-webkit-color-swatch {
    border: none;
    border-radius: 50%;
  }

  label {
    margin-top: var(--sp-5);
    font-size: var(--fs-md);
    cursor: help;
    position: relative;
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  label:hover + .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateX(-50%) translateY(-10px);
  }
`;

// ===== COMPONENTES DE SLIDER =====
export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
  width: 100%;
`;

export const SliderLabel = styled.span`
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
  text-align: center;
`;

export const Slider = styled.input<{ color?: string }>`
  width: 100%;
  height: calc(var(--u) * 6);
  border-radius: 3px;
  background: #ddd;
  outline: none;
  -webkit-appearance: none;
  margin: var(--sp-10) 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: calc(var(--u) * 20);
    height: calc(var(--u) * 20);
    border-radius: 50%;
    background: ${(props) => props.color || props.theme.colors.selection};
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;
  }

  &::-webkit-slider-thumb:hover {
    transform: scale(1.1);
  }

  &::-moz-range-thumb {
    width: calc(var(--u) * 20);
    height: calc(var(--u) * 20);
    border-radius: 50%;
    background: ${(props) => props.color || props.theme.colors.selection};
    cursor: pointer;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

// ===== COMPONENTES DE CHECKBOX =====
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  padding: var(--sp-8) 0;
`;

export const CheckboxInput = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  .checkmark {
    width: calc(var(--u) * 20);
    height: calc(var(--u) * 20);
    border: 2px solid ${(props) => props.theme.colors.selection};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background: ${(props) => props.theme.colors.background};
  }

  input[type="checkbox"]:checked + .checkmark {
    background-color: ${(props) => props.theme.colors.selection};
    border-color: ${(props) => props.theme.colors.selection};
  }

  input[type="checkbox"]:checked + .checkmark::after {
    content: "✓";
    color: white;
    font-size: var(--fs-md);
    font-weight: bold;
  }

  input[type="checkbox"]:focus + .checkmark {
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
  }
`;

export const CheckboxLabel = styled.span<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
  font-weight: ${(props) => (props.active ? "600" : "400")};
`;

// ===== COMPONENTES DE ALERTA =====
export const AlertMessage = styled.div<{
  type: "info" | "warning" | "error" | "success";
}>`
  display: flex;
  align-items: flex-start;
  gap: var(--sp-12);
  padding: var(--sp-16);
  border-radius: 8px;
  background-color: ${(props) => {
    switch (props.type) {
      case "info":
        return "#E3F2FD";
      case "warning":
        return "#FFF3E0";
      case "error":
        return "#FFEBEE";
      case "success":
        return "#E8F5E8";
      default:
        return "#E3F2FD";
    }
  }};
  color: ${(props) => {
    switch (props.type) {
      case "info":
        return "#1565C0";
      case "warning":
        return "#E65100";
      case "error":
        return "#C62828";
      case "success":
        return "#2E7D32";
      default:
        return "#1565C0";
    }
  }};
  border-left: 4px solid
    ${(props) => {
      switch (props.type) {
        case "info":
          return "#2196F3";
        case "warning":
          return "#FF9800";
        case "error":
          return "#F44336";
        case "success":
          return "#4CAF50";
        default:
          return "#2196F3";
      }
    }};
  margin: var(--sp-16) 0;

  .material-icons {
    font-size: var(--fs-2xl);
    flex-shrink: 0;
  }

  div {
    flex: 1;

    strong {
      display: block;
      margin-bottom: var(--sp-4);
    }
  }
`;

// ===== COMPONENTES DE BADGE =====
export const CategoryBadge = styled.span<{ category: string }>`
  display: inline-block;
  padding: var(--sp-4) var(--sp-8);
  border-radius: 12px;
  font-size: var(--fs-3xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: calc(var(--u) * 0.5);
  background-color: ${(props) => {
    switch (props.category) {
      case "pdv":
        return "#E3F2FD";
      case "mobilia":
        return "#E8F5E8";
      case "equipamento":
        return "#FFF3E0";
      case "cozinha":
        return "#FFEBEE";
      case "tecnologia":
        return "#F3E5F5";
      case "caixa":
        return "#E0F2F1";
      case "ambiente":
        return "#FFF8E1";
      case "auxiliar":
        return "#ECEFF1";
      default:
        return "#E3F2FD";
    }
  }};
  color: ${(props) => {
    switch (props.category) {
      case "pdv":
        return "#1565C0";
      case "mobilia":
        return "#2E7D32";
      case "equipamento":
        return "#E65100";
      case "cozinha":
        return "#C62828";
      case "tecnologia":
        return "#7B1FA2";
      case "caixa":
        return "#00695C";
      case "ambiente":
        return "#F57F17";
      case "auxiliar":
        return "#37474F";
      default:
        return "#1565C0";
    }
  }};
  margin-left: var(--sp-8);
`;

// ===== COMPONENTES DE BOTÃO =====
export const ButtonGroup = styled.div`
  display: flex;
  gap: var(--sp-12);
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  padding: var(--sp-12) var(--sp-24);
  background-color: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: var(--fs-md);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors.selectionDark};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-12) var(--sp-24);
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  cursor: pointer;
  font-size: var(--fs-md);
  font-weight: 500;
  transition: background-color 0.2s, transform 0.2s;
  gap: var(--sp-8);

  &:hover {
    background-color: #e8e8e8;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Button = styled.button<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-12) var(--sp-24);
  border-radius: 8px;
  border: none;
  background-color: ${(props) => props.color || props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  font-weight: 600;
  font-size: var(--fs-md);
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s, opacity 0.2s;
  gap: var(--sp-8);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

// ===== COMPONENTES DE ARQUIVO =====
export const FileInputContainer = styled.div`
  position: relative;
  display: inline-block;
  width: fit-content;
  cursor: pointer;
`;

export const FileInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const FileInputLabel = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-5) var(--sp-10);
  margin: var(--sp-5);
  border-radius: 8px;
  color: #ffffff;
  background-color: ${(props) => props.color || "#000"};
  font-size: var(--fs-base);
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

// ===== COMPONENTES DE TEXTO =====
export const TextArea = styled.div<{ fullWidth?: boolean }>`
  position: relative;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};

  textarea {
    width: 100%;
    padding: var(--sp-12);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 8px;
    outline: none;
    background: ${(props) => props.theme.colors.selection + "20"};
    resize: vertical;
    font-family: inherit;
    font-size: var(--fs-md);
    transition: all 0.2s ease;

    &:focus {
      background-color: ${(props) =>
        (props.theme.colors.primary || props.theme.colors.selection) + "20"};
      border-color: ${(props) => props.theme.colors.selection};
      box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
    }
  }

  label {
    position: absolute;
    top: calc(var(--u) * -8);
    left: calc(var(--u) * 12);
    background: ${(props) => props.theme.colors.modalColor};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-8);
    font-size: var(--fs-xs);
    font-weight: 600;
  }
`;

// ===== COMPONENTES DE OPÇÕES DE VENDA =====
export const SaleOptionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-24);
  padding-bottom: var(--sp-16);
  border-bottom: 2px solid ${(props) => props.theme.colors.border};
`;

export const SaleOptionItem = styled.div<{ selected: boolean }>`
  padding: var(--sp-16);
  margin-bottom: var(--sp-12);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--sp-12);
  border: 2px solid
    ${({ selected, theme }) =>
      selected ? theme.colors.selection : theme.colors.border};
  border-radius: 8px;
  transition: all 0.3s ease;
  color: ${({ selected }) => (selected ? "#000000" : "inherit")};
  background: ${({ selected }) =>
    selected ? "rgba(255, 196, 0, 0.372)" : "transparent"};

  &:hover {
    color: "#000000";
    background: rgba(255, 196, 0, 0.372);
    transform: translateX(4px);
    border-color: ${(props) => props.theme.colors.selection};
  }

  div {
    display: flex;
    flex-direction: column;
    flex: 1;

    div:first-child {
      font-weight: 600;
      font-size: var(--fs-md);
    }

    small {
      font-size: var(--fs-xs);
      opacity: 0.8;
    }
  }
`;

export const SaleOptionsContainer = styled.div`
  display: flex;
  gap: var(--sp-24);
  height: calc(var(--u) * 500);
`;

export const SaleOptionsList = styled.div`
  width: calc(var(--u) * 320);
  border-right: 1px solid ${(props) => props.theme.colors.border};
  padding-right: var(--sp-20);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: calc(var(--u) * 8);
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background + "40"};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.selection};
    border-radius: 4px;
  }
`;

export const SaleOptionConfig = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 var(--sp-24);

  &::-webkit-scrollbar {
    width: calc(var(--u) * 8);
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background + "40"};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.selection};
    border-radius: 4px;
  }
`;

// ===== COMPONENTES DE PREVIEW =====
export const PreviewComponent = styled.div<{
  backgroundColor: string;
  viewType: "retrato" | "paisagem";
}>`
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  width: ${(props) => (props.viewType === "retrato" ? "50%" : "100%")};
  height: ${(props) => (props.viewType === "retrato" ? "90%" : "60%")};
  max-width: 100%;
  max-height: 100%;
`;

export const PreviewLogo = styled.img<{
  logoWidth: number;
  logoHeight: number;
}>`
  width: ${(props) => props.logoWidth}px;
  height: ${(props) => props.logoHeight}px;
  border-radius: 25%;
  &:hover {
    box-shadow: 0px 0px 30px #1d50ffff;
  }
  transition: box-shadow 0.5s ease-in-out;
  cursor: pointer;
`;

export const PreviewHomeMessage = styled.div<{ textColor: string }>`
  color: ${(props) => props.textColor};
  font-weight: bold;
  font-size: var(--fs-3xs);
  margin-bottom: var(--sp-20);
`;

export const PreviewAccessButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--sp-20);
`;

export const PreviewAccessButton = styled.button<{
  title?: string;
  buttonsColor: string;
  textColor: string;
  width: string;
  height: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.textColor};
  border-radius: 20%;
  background-color: ${(props) => props.buttonsColor};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  position: relative;
  &:hover {
    box-shadow: 0px 0px 50px white;
  }
  transition: box-shadow 0.5s ease-in-out;
  cursor: pointer;
  &::after {
    content: "${(props) => props.title}";
    font-size: calc(var(--u) * 5);
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
`;

export const PreviewAccessButtonImg = styled.img`
  align-self: center;
`;

export const PreviewLogButton = styled.button<{
  textColor: string;
  buttonsColor: string;
}>`
  text-decoration: none;
  margin-top: var(--sp-2);
  padding: calc(var(--u) * 1) var(--sp-2);
  border-radius: 5px;
  color: ${(props) => props.textColor};
  background-color: ${(props) => props.buttonsColor};
  font-weight: bold;
  font-size: calc(var(--u) * 8);
  cursor: pointer;
`;

// ===== EDITOR DE COMPONENTES =====
export const ComponentEditorOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
`;

export const ComponentEditor = styled.div`
  background: ${(props) => props.theme.colors.modalColor};
  border-radius: 12px;
  padding: 0;
  width: calc(var(--u) * 600);
  max-width: 90vw;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      transform: translateY(30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ComponentEditorHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--sp-20);
  border-bottom: 1px solid ${(props) => props.theme.colors.border};

  h3 {
    margin: 0;
    color: ${(props) => props.theme.colors.selection};
    font-size: var(--fs-lg);
    font-weight: 600;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: ${(props) => props.theme.colors.text};
    font-size: var(--fs-xl);
    padding: var(--sp-4);
    border-radius: 4px;

    &:hover {
      background-color: ${(props) => props.theme.colors.selection + "20"};
    }
  }
`;

export const ComponentEditorBody = styled.div`
  padding: var(--sp-20);
  overflow-y: auto;
  max-height: 60vh;
`;

// ===== COMPONENTES DO VISUAL BUILDER =====
/*
 * O CONSTRUTOR EM TELA CHEIA.
 *
 * A queixa do Guilherme: "o site builder do PDV está dentro de um modal e por
 * isso fica difícil de mostrar o preview". Era verdade — o construtor tem TRÊS
 * colunas (biblioteca, prévia, propriedades) e vivia numa caixa de 600 de
 * altura dentro de um modal que já é uma caixa. A prévia, que é a razão de o
 * construtor existir, ficava com a menor parte.
 *
 * `$cheia` tira o construtor do fluxo do modal e o põe sobre a janela inteira.
 * É o mesmo idioma que a `DynamicTable` já usa para expandir (position: fixed +
 * inset: 0), então não é padrão novo nesta base.
 *
 * O que isto NÃO é: a rota própria. O salvamento do item mora dentro do
 * `handleSave` da Configuração, com o tratamento da fila do PDV junto — mover
 * isso para uma página é refactor de outra ordem. A tela cheia resolve o
 * problema do PREVIEW hoje, sem duplicar caminho de escrita.
 */
export const VisualBuilderWrapper = styled.div<{ $cheia?: boolean }>`
  width: 100%;
  height: 100%;
  position: relative;

  ${(props) =>
    props.$cheia &&
    `
    position: fixed;
    inset: 0;
    z-index: 10000;
    width: 100vw;
    height: 100vh;
    padding: calc(var(--u) * 56) var(--sp-16) var(--sp-16);
    background-color: ${props.theme.colors.background};
    overflow: auto;
  `}
`;

/** A barra que aparece só no modo tela cheia, com o botão de sair. */
export const BarraDaTelaCheia = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-12);
  padding: var(--sp-8) var(--sp-16);
  background-color: ${(props) => props.theme.colors.modalColor};
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  font-weight: 700;
  color: ${(props) => props.theme.colors.text};
`;

export const BotaoDaTelaCheia = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--sp-6);
  min-height: max(calc(var(--u) * 44), 40px);
  padding: var(--sp-6) var(--sp-12);
  border: 1px solid ${(props) => props.theme.colors.selection};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  font-size: var(--fs-xs);
  font-weight: 600;
  cursor: pointer;

  .material-icons {
    font-family: "Material Icons";
    font-size: var(--fs-base);
  }
`;

export const ComponentLibrary = styled.div`
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const LibraryHeader = styled.div`
  padding: var(--sp-16);
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  background: ${(props) => props.theme.colors.modalColor};
`;

export const SearchInput = styled.div`
  position: relative;
  margin-top: var(--sp-12);

  input {
    width: 100%;
    padding: var(--sp-8) var(--sp-32) var(--sp-8) var(--sp-12);
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 6px;
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
    font-size: var(--fs-md);

    &:focus {
      outline: none;
      border-color: ${(props) => props.theme.colors.selection};
    }
  }

  .material-icons {
    position: absolute;
    right: calc(var(--u) * 8);
    top: 50%;
    transform: translateY(-50%);
    color: ${(props) => props.theme.colors.label};
    font-size: var(--fs-lg);
  }
`;

export const ComponentsList = styled.div`
  flex: 1;
  padding: var(--sp-16);
  overflow-y: auto;
  max-height: calc(var(--u) * 400);
`;

export const LibraryFooter = styled.div`
  padding: var(--sp-16);
  border-top: 1px solid ${(props) => props.theme.colors.border};
  background: ${(props) => props.theme.colors.modalColor};
`;

export const TipBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--sp-8);
  padding: var(--sp-12);
  background: ${(props) => props.theme.colors.selection + "20"};
  border: 1px solid ${(props) => props.theme.colors.selection + "40"};
  border-radius: 6px;
  font-size: var(--fs-xs);

  .material-icons {
    color: ${(props) => props.theme.colors.selection};
    font-size: var(--fs-base);
    flex-shrink: 0;
  }

  div {
    flex: 1;

    strong {
      display: block;
      margin-bottom: var(--sp-2);
      color: ${(props) => props.theme.colors.selection};
    }
  }
`;

export const BuilderMain = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  overflow: hidden;
`;

export const PreviewContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--sp-16);
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  background: ${(props) => props.theme.colors.modalColor};
`;

export const PreviewTitle = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  font-weight: 600;
  font-size: var(--fs-base);
  color: ${(props) => props.theme.colors.text};
`;

export const PreviewBadge = styled.span`
  background: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  padding: var(--sp-4) var(--sp-8);
  border-radius: 12px;
  font-size: var(--fs-3xs);
  font-weight: 600;
  text-transform: uppercase;
`;

export const PreviewActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-12);
`;

export const ZoomControls = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  background: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 6px;
  padding: var(--sp-4);

  button {
    background: none;
    border: none;
    color: ${(props) => props.theme.colors.text};
    cursor: pointer;
    width: calc(var(--u) * 24);
    height: calc(var(--u) * 24);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    &:hover {
      background: ${(props) => props.theme.colors.selection + "20"};
    }

    .material-icons {
      font-size: var(--fs-base);
    }
  }

  span {
    font-size: var(--fs-xs);
    font-weight: 600;
    min-width: calc(var(--u) * 40);
    text-align: center;
  }
`;

export const InteractivePreview = styled(PreviewComponent)`
  position: relative;
  flex: 1;
  margin: var(--sp-20);
  border: 2px dashed ${(props) => props.theme.colors.border};
  cursor: crosshair;
  overflow: visible !important;

  &:hover {
    border-color: ${(props) => props.theme.colors.selection};
  }
`;

export const DropTarget = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: var(--sp-40);
  color: ${(props) => props.theme.colors.label};
`;

export const EmptyStateIcon = styled.div`
  font-size: var(--fs-6xl);
  color: ${(props) => props.theme.colors.label};
  margin-bottom: var(--sp-16);

  .material-icons {
    font-size: var(--fs-6xl);
  }
`;

export const EmptyStateTitle = styled.h3`
  font-size: var(--fs-lg);
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: var(--sp-8);
`;

export const EmptyStateDescription = styled.p`
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.label};
  margin-bottom: var(--sp-20);
  max-width: calc(var(--u) * 300);
  line-height: 1.4;
`;

export const EmptyStateAction = styled.div`
  button {
    display: flex;
    align-items: center;
    gap: var(--sp-8);
    padding: var(--sp-10) var(--sp-16);
    background: ${(props) => props.theme.colors.selection};
    color: ${(props) => props.theme.colors.textOnPrimary};
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
      background: ${(props) => props.theme.colors.selectionDark};
      transform: translateY(-2px);
    }

    .material-icons {
      font-size: var(--fs-lg);
    }
  }
`;

export const PreviewFooter = styled.div`
  padding: var(--sp-16);
  border-top: 1px solid ${(props) => props.theme.colors.border};
  background: ${(props) => props.theme.colors.modalColor};
  display: flex;
  justify-content: center;
`;

export const DeviceMockup = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
`;

export const DeviceFrame = styled.div`
  padding: var(--sp-8) var(--sp-16);
  background: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 20px;
  font-size: var(--fs-xs);
  color: ${(props) => props.theme.colors.label};
`;

export const ScreenSize = styled.span`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`;

export const PropertiesPanel = styled.div`
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const PropertiesHeader = styled.div`
  padding: var(--sp-16);
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  background: ${(props) => props.theme.colors.modalColor};
`;

export const PropertiesContent = styled.div`
  flex: 1;
  padding: var(--sp-16);
  overflow-y: auto;
`;

// ===== COMPONENTES DE DRAG & DROP =====
export const DraggableComponent = styled.div<{
  isDragging: boolean;
  isOver: boolean;
  isSelected: boolean;
}>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid
    ${(props) =>
      props.isSelected ? "#FFC400" : props.isOver ? "#4CAF50" : "transparent"};
  border-radius: 8px;
  cursor: move;
  transition: all 0.2s ease;
  z-index: ${(props) => (props.isDragging ? 1000 : props.isSelected ? 100 : 1)};
  opacity: ${(props) => (props.isDragging ? 0.7 : 1)};
  transform: ${(props) => (props.isDragging ? "rotate(5deg)" : "none")};
  box-shadow: ${(props) =>
    props.isSelected
      ? "0 4px 20px rgba(255, 196, 0, 0.4)"
      : props.isOver
      ? "0 4px 15px rgba(76, 175, 80, 0.3)"
      : "0 2px 8px rgba(0, 0, 0, 0.15)"};
  overflow: hidden;
  min-width: calc(var(--u) * 80);
  min-height: calc(var(--u) * 40);

  &:hover {
    border-color: ${(props) => props.theme.colors.selection};
    box-shadow: 0 4px 15px rgba(29, 80, 255, 0.3);
  }
`;

export const ComponentHandle = styled.div`
  position: absolute;
  top: calc(var(--u) * 2);
  left: calc(var(--u) * 2);
  cursor: move;
  color: rgba(255, 255, 255, 0.8);
  font-size: var(--fs-base);
  z-index: 10;

  .material-icons {
    font-size: var(--fs-base);
  }
`;

export const ComponentContent = styled.div`
  flex: 1;
  text-align: center;
  font-size: var(--fs-xs);
  font-weight: 600;
  color: inherit;
  padding: var(--sp-8) var(--sp-4);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ComponentActions = styled.div`
  position: absolute;
  top: calc(var(--u) * 2);
  right: calc(var(--u) * 2);
  display: flex;
  gap: var(--sp-2);
  z-index: 10;

  button {
    background: rgba(0, 0, 0, 0.6);
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    width: calc(var(--u) * 20);
    height: calc(var(--u) * 20);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--fs-xs);
    transition: background-color 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.8);
    }

    .material-icons {
      font-size: var(--fs-md);
    }
  }
`;

export const DragPreviewLayer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const DragPreviewItem = styled.div`
  background: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  padding: var(--sp-8) var(--sp-12);
  border-radius: 6px;
  font-size: var(--fs-xs);
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
  white-space: nowrap;
`;

export const DraggableComponentItem = styled.div<{ isDragging: boolean }>`
  display: flex;
  align-items: center;
  padding: var(--sp-12);
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.background + "40"};
  cursor: grab;
  transition: all 0.2s ease;
  margin-bottom: var(--sp-8);
  opacity: ${(props) => (props.isDragging ? 0.5 : 1)};
  transform: ${(props) => (props.isDragging ? "scale(0.95)" : "none")};

  &:hover {
    border-color: ${(props) => props.theme.colors.selection};
    background: ${(props) => props.theme.colors.selection + "20"};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &:active {
    cursor: grabbing;
  }
`;

export const ComponentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--u) * 40);
  height: calc(var(--u) * 40);
  background: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  border-radius: 6px;
  margin-right: var(--sp-12);

  .material-icons {
    font-size: var(--fs-xl);
  }
`;

export const ComponentInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ComponentName = styled.div`
  font-weight: 600;
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.text};
  margin-bottom: var(--sp-4);
`;

export const ComponentDescription = styled.div`
  font-size: var(--fs-xs);
  color: ${(props) => props.theme.colors.label};
`;

export const DragHandle = styled.div`
  color: ${(props) => props.theme.colors.label};
  cursor: grab;

  .material-icons {
    font-size: var(--fs-lg);
  }

  &:active {
    cursor: grabbing;
  }
`;

// ===== EDITOR DE PROPRIEDADES =====
export const PropertiesForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-20);
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);

  label {
    font-weight: 600;
    font-size: var(--fs-xs);
    color: ${(props) => props.theme.colors.text};
    text-transform: uppercase;
    letter-spacing: calc(var(--u) * 0.5);
  }
`;

export const Grid2x2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-16);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FormSection = styled.div`
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  padding: var(--sp-20);
  margin-bottom: var(--sp-16);
`;

export const VisualBuilderContainer = styled.div`
  display: grid;
  grid-template-columns: calc(var(--u) * 300) 1fr calc(var(--u) * 350);
  gap: var(--sp-20);
  height: 100%;
  /* Em tela cheia o pai já dá a altura; o mínimo de 600 é para o modo modal. */
  min-height: min(calc(var(--u) * 600), 100%);

  @media (max-width: 1200px) {
    grid-template-columns: calc(var(--u) * 280) 1fr;
    grid-template-rows: auto 1fr;

    ${PropertiesPanel} {
      grid-column: 1 / -1;
      grid-row: 2;
      height: calc(var(--u) * 300);
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;

    ${ComponentLibrary} {
      grid-row: 1;
    }

    ${BuilderMain} {
      grid-row: 2;
    }

    ${PropertiesPanel} {
      grid-row: 3;
    }
  }
`;
// Exportação padrão para compatibilidade
export default {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalContainer,
  ModalBody,
  ModalTitle,
  ModalCloseButton,
  ModalFooter,
  ItemContainer,
  ItemTopContainer,
  ItemBottom,
  ItemInfoContainer,
  ItemInfoFields,
  ItemInfo,
  Column,
  LabelInputContainer,
  Label,
  TextInput,
  DropdownInput,
  InfoGrid,
  InfoItem,
  InfoLabel,
  InfoValue,
  FieldsContainer,
  SectionTitle,
  FormSection,
  FormGrid,
  ColorGrid,
  InputWrapper,
  Input,
  Select,
  ColorInput,
  SliderContainer,
  Slider,
  SliderLabel,
  CheckboxContainer,
  CheckboxInput,
  CheckboxLabel,
  AlertMessage,
  CategoryBadge,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  Button,
  FileInputContainer,
  FileInput,
  FileInputLabel,
  TextArea,
  SaleOptionsHeader,
  SaleOptionItem,
  SaleOptionsContainer,
  SaleOptionsList,
  SaleOptionConfig,
  PreviewComponent,
  PreviewLogo,
  PreviewHomeMessage,
  PreviewAccessButtonsContainer,
  PreviewAccessButton,
  PreviewAccessButtonImg,
  PreviewLogButton,
  ComponentEditorOverlay,
  ComponentEditor,
  ComponentEditorHeader,
  ComponentEditorBody,
  VisualBuilderWrapper,
  VisualBuilderContainer,
  ComponentLibrary,
  LibraryHeader,
  SearchInput,
  ComponentsList,
  LibraryFooter,
  TipBox,
  BuilderMain,
  PreviewContainer,
  PreviewHeader,
  PreviewTitle,
  PreviewBadge,
  PreviewActions,
  ZoomControls,
  InteractivePreview,
  DropTarget,
  EmptyState,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateDescription,
  EmptyStateAction,
  PreviewFooter,
  DeviceMockup,
  DeviceFrame,
  ScreenSize,
  PropertiesPanel,
  PropertiesHeader,
  PropertiesContent,
  DraggableComponent,
  ComponentHandle,
  ComponentContent,
  ComponentActions,
  DragPreviewLayer,
  DragPreviewItem,
  DraggableComponentItem,
  ComponentIcon,
  ComponentInfo,
  ComponentName,
  ComponentDescription,
  DragHandle,
  PropertiesForm,
  InputGroup,
  Grid2x2,
};
